import React, { FunctionComponent } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./style";
import { SegmentRule, RuleParameter } from "../../../models/Segment";
import { AddCircle, PlaylistAddCheck } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";

export interface RuleProps {
  rule: SegmentRule;
  onChange: (rule: SegmentRule) => void;
  onDelete: (index: number) => void;
}

export const Rule: FunctionComponent<RuleProps> = ({
  rule,
  onChange,
  onDelete
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleChange = (e: any, index: number, valueIndex: number) => {
    if (rule.parameters[index].isListType) {
      if (!rule.parameters[index].value) rule.parameters[index].value = [];
      rule.parameters[index].value[valueIndex] = e.target.value;
    } else {
      rule.parameters[index].value = e.target.value;
    }

    onChange(rule);
  };

  return (
    <>
      <Card variant={"outlined"} key={rule.order}>
        <CardHeader
          style={{ padding: "4px 8px 0px 8px" }}
          avatar={
            <Avatar
              style={{
                width: 24,
                height: 24,
                backgroundColor: !rule.hasQuery
                  ? theme.palette.primary.main
                  : theme.palette.secondary.main
              }}
              aria-label="recipe"
            >
              <PlaylistAddCheck style={{ width: 16, height: 16 }} />
            </Avatar>
          }
          title={rule.name}
          action={
            <IconButton aria-label="settings" onClick={() => onDelete(rule.id)}>
              <DeleteIcon />
            </IconButton>
          }
        />
        <CardContent>
          <Grid container item xs={12} spacing={3}>
            {rule.parameters.map((parameter: RuleParameter, i: number) => (
              <>
                <Grid item xs={6}>
                  {parameter.isListType ? (
                    parameter.value.map((value: any, j: number) => (
                      <div style={{ display: "flex", width: "100%" }}>
                        <TextField
                          style={{ width: "100%" }}
                          className={classes.field}
                          name={`${rule.order}_${i}`}
                          label={parameter.label ?? parameter.name}
                          type={parameter.type}
                          value={value ?? ""}
                          onChange={(event: any) => handleChange(event, i, j)}
                        />
                        {parameter.value.length - 1 !== j ? (
                          <IconButton
                            onClick={() => {
                              parameter.value = parameter.value.filter(
                                (_: any, index: number) => j !== index
                              );
                              onChange(rule);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        ) : (
                          <IconButton
                            style={{
                              color: !parameter.value[
                                parameter.value.length - 1
                              ].length
                                ? theme.palette.grey[500]
                                : "rgb(31, 132, 52)"
                            }}
                            disabled={
                              !parameter.value[parameter.value.length - 1]
                                .length
                            }
                            onClick={() => {
                              if (!parameter.value) parameter.value = [];
                              parameter.value = [...parameter.value, ""];
                              onChange(rule);
                            }}
                          >
                            <AddCircle />
                          </IconButton>
                        )}
                      </div>
                    ))
                  ) : parameter.options ? (
                    <FormControl
                      className={classes.field}
                      variant={"standard"}
                      required
                    >
                      <InputLabel id="type-select-label">
                        {parameter.label ?? parameter.name}
                      </InputLabel>
                      <Select
                        labelId="type-select-label"
                        value={parameter.value ?? ""}
                        onChange={e => handleChange(e, i, 0)}
                      >
                        {parameter.options.map((p, index) => (
                          <MenuItem
                            key={index}
                            value={parameter.type === "Number" ? index : p}
                          >
                            {p}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      className={classes.field}
                      name={`${rule.order}_${i}`}
                      label={parameter.label ?? parameter.name}
                      type={parameter.type}
                      value={parameter.value ?? ""}
                      onChange={(event: any) => handleChange(event, i, 0)}
                    />
                  )}
                </Grid>
              </>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
